
import Vue, { PropType } from 'vue'
import { Block } from '@interfaces/BlockTypes'

export default Vue.extend({
  name: 'CommonFeaturesBlock',
  props: {
    block: {
      type: Object as PropType<Block>,
      required: true,
    },
  },

  data() {
    return {
      observer: null as any,
      autoSwitchTimer: 0 as any,
      featureSelected: 0,
      showContent: false,
      isExpanded: false,
      showReadMore: false,
      featureStates: [true],
      isMobile:
        typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
    }
  },

  components: {},
  created() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.checkMobile)
    }
  },
  mounted() {
    this.featureStates = Array(this.block?.features?.length).fill(false)
    this.$set(this.featureStates, 0, true)
    if (Array.isArray(this.block?.features)) {
      this.block?.features.forEach((feature) => {
        const img = new Image()
        img.src = feature.extraContent
      })
    }
    const observerOptions = {
      root: null,
      threshold: 0.5,
    }

    this.observer = new IntersectionObserver(
      this.handleIntersect,
      observerOptions
    )
    this.observer.observe(this.$refs.featureContainer)
  },
  methods: {
    selectFeature(index: number) {
      this.featureSelected = index
    },
    selectNextFeature() {
      const numberOfFeatures = Object.keys(this.block?.features).length
      this.$set(this.featureStates, this.featureSelected, false)
      this.featureSelected = (this.featureSelected + 1) % numberOfFeatures
      this.$set(this.featureStates, this.featureSelected, true)

      clearTimeout(this.autoSwitchTimer)
      this.autoSwitchTimer = 0
      this.setAutoSwitch()
    },
    toggleText(index: number) {
      this.$set(this.featureStates, index, !this.featureStates[index])
    },
    handleClick(index: number) {
      this.featureStates = Array(this.block?.features?.length).fill(false)
      this.featureStates[index] = true
      this.selectFeature(index)
      this.clearAutoSwitchTimer()
    },
    checkMobile() {
      if (typeof window !== 'undefined') {
        this.isMobile = window.innerWidth <= 992
      }
    },
    setAutoSwitch() {
      if (this.autoSwitchTimer !== 0) {
        return
      }

      if (
        this.block &&
        this.block?.features &&
        this.block?.features[this.featureSelected]
      ) {
        const duration =
          (this.block?.features[this.featureSelected].duration || 5) * 1000
        this.autoSwitchTimer = setTimeout(this.selectNextFeature, duration)
      }
    },
    clearAutoSwitchTimer() {
      clearTimeout(this.autoSwitchTimer)
      this.autoSwitchTimer = 0
    },
    handleIntersect(entries: IntersectionObserverEntry[]) {
      if (entries[0].isIntersecting) {
        this.setAutoSwitch()
      } else {
        this.clearAutoSwitchTimer()
      }
    },
  },
  destroyed() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.checkMobile)
    }
    this.clearAutoSwitchTimer()
  },
})
